"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoInternet = void 0;
const react_1 = __importDefault(require("react"));
const S = __importStar(require("./NoInternet.styles"));
const atoms_1 = require("../../../atoms");
const NoInternetIcon_1 = __importDefault(require("./NoInternetIcon"));
const ErrorFallback_1 = require("../ErrorFallback");
const labels_1 = require("../labels");
const accessibility_1 = require("../../../../../shared/accessibility");
exports.NoInternet = ({ onPress, heading = labels_1.Labels.noInternetHeading, message = labels_1.Labels.noInternetMessage, buttonText = labels_1.Labels.noInternetButtonText, }) => (react_1.default.createElement(S.NoInternetContainer, null,
    react_1.default.createElement(ErrorFallback_1.ErrorFallback, { image: react_1.default.createElement(S.ImageContainer, Object.assign({}, accessibility_1.accessibilityProps('no-internet-error-icon')),
            react_1.default.createElement(NoInternetIcon_1.default, null)), heading: react_1.default.createElement(S.Heading, Object.assign({ ellipsizeMode: "tail" }, accessibility_1.accessibilityProps('no-internet-error-heading')), heading), message: react_1.default.createElement(S.Message, Object.assign({}, accessibility_1.accessibilityProps('no-internet-error-message'), { type: atoms_1.PTextType.VALUE }), message), button: react_1.default.createElement(S.ButtonWrapper, null,
            react_1.default.createElement(atoms_1.Button, Object.assign({}, accessibility_1.accessibilityProps('no-internet-retry-button'), { testID: "no-internet-retry-button", type: atoms_1.ButtonAction.SECONDARY, onPress: onPress, size: atoms_1.ButtonSize.SMALL }), buttonText)) })));
